// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_core__Grpc from "../../../../packages/core/lib/Grpc.js";
import * as Buhta_core__GrpcState from "../../../../packages/core/lib/GrpcState.js";
import * as Buhta_keychainapis__Buhta_keychain_v1_credential_service from "../../../../proto/keychainapis/gen/buhta_keychain_v1_credential_service.js";
import * as Buhta_keychainapis__Buhta_keychain_v1_key_service from "../../../../proto/keychainapis/gen/buhta_keychain_v1_key_service.js";
import * as Curry from "melange.js/curry.js";

const Credential = {};

const Key = {};

function toCreateRequest(org, form) {
  return Curry._3(Buhta_keychainapis__Buhta_keychain_v1_credential_service.Buhta.Keychain.V1.CreateCredentialRequest.make, org, form, undefined);
}

function toUpdateRequest(id, form) {
  return Curry._3(Buhta_keychainapis__Buhta_keychain_v1_credential_service.Buhta.Keychain.V1.UpdateCredentialRequest.make, id, form, undefined);
}

const CredentialForm = {
  toCreateRequest: toCreateRequest,
  toUpdateRequest: toUpdateRequest
};

function toCreateRequest$1(org, form) {
  return Curry._3(Buhta_keychainapis__Buhta_keychain_v1_key_service.Buhta.Keychain.V1.CreateKeyRequest.make, org, form, undefined);
}

function toUpdateRequest$1(id, form) {
  return Curry._3(Buhta_keychainapis__Buhta_keychain_v1_key_service.Buhta.Keychain.V1.UpdateKeyRequest.make, id, form, undefined);
}

const KeyForm = {
  toCreateRequest: toCreateRequest$1,
  toUpdateRequest: toUpdateRequest$1
};

function view(tenant, expand, id, param) {
  const request = Curry._3(Buhta_keychainapis__Buhta_keychain_v1_key_service.Buhta.Keychain.V1.GetKeyRequest.make, id, Belt__Belt_Option.getWithDefault(expand, /* [] */ 0), undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.key);
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_keychainapis__Buhta_keychain_v1_key_service.Buhta.Keychain.V1.KeyService.getKey, undefined, undefined, tenant, Buhta_keychainapis__Buhta_keychain_v1_key_service.Buhta.Keychain.V1.KeyService.GetKey.name, undefined, undefined));
}

function grid(tenant, params, param) {
  const request = Curry._2(Buhta_keychainapis__Buhta_keychain_v1_key_service.Buhta.Keychain.V1.ListKeysRequest.make, Buhta_core__GrpcState.makeGridRequest(params, undefined), undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return response.keys;
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_keychainapis__Buhta_keychain_v1_key_service.Buhta.Keychain.V1.KeyService.listKeys, undefined, undefined, tenant, Buhta_keychainapis__Buhta_keychain_v1_key_service.Buhta.Keychain.V1.KeyService.ListKeys.name, undefined, undefined));
}

function create(tenant, request) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.key);
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_keychainapis__Buhta_keychain_v1_key_service.Buhta.Keychain.V1.KeyService.createKey, undefined, undefined, tenant, Buhta_keychainapis__Buhta_keychain_v1_key_service.Buhta.Keychain.V1.KeyService.CreateKey.name, undefined, undefined));
}

function update(tenant, id, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.key);
  }), Buhta_core__Grpc.makeRpc(undefined, Curry._3(Buhta_keychainapis__Buhta_keychain_v1_key_service.Buhta.Keychain.V1.UpdateKeyRequest.make, id, form, undefined), Buhta_keychainapis__Buhta_keychain_v1_key_service.Buhta.Keychain.V1.KeyService.updateKey, undefined, undefined, tenant, Buhta_keychainapis__Buhta_keychain_v1_key_service.Buhta.Keychain.V1.KeyService.UpdateKey.name, undefined, undefined));
}

const KeyService = {
  view: view,
  grid: grid,
  create: create,
  update: update
};

function view$1(tenant, expand, id, param) {
  const request = Curry._3(Buhta_keychainapis__Buhta_keychain_v1_credential_service.Buhta.Keychain.V1.GetCredentialRequest.make, id, Belt__Belt_Option.getWithDefault(expand, {
    hd: "username",
    tl: {
      hd: "password",
      tl: {
        hd: "memo",
        tl: /* [] */ 0
      }
    }
  }), undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.credential);
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_keychainapis__Buhta_keychain_v1_credential_service.Buhta.Keychain.V1.CredentialService.getCredential, undefined, undefined, tenant, Buhta_keychainapis__Buhta_keychain_v1_credential_service.Buhta.Keychain.V1.CredentialService.GetCredential.name, undefined, undefined));
}

function grid$1(tenant, params, param) {
  const request = Curry._2(Buhta_keychainapis__Buhta_keychain_v1_credential_service.Buhta.Keychain.V1.ListCredentialsRequest.make, Buhta_core__GrpcState.makeGridRequest(params, undefined), undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return response.credentials;
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_keychainapis__Buhta_keychain_v1_credential_service.Buhta.Keychain.V1.CredentialService.listCredentials, undefined, undefined, tenant, Buhta_keychainapis__Buhta_keychain_v1_credential_service.Buhta.Keychain.V1.CredentialService.ListCredentials.name, undefined, undefined));
}

function create$1(tenant, request) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.credential);
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_keychainapis__Buhta_keychain_v1_credential_service.Buhta.Keychain.V1.CredentialService.createCredential, undefined, undefined, tenant, Buhta_keychainapis__Buhta_keychain_v1_credential_service.Buhta.Keychain.V1.CredentialService.CreateCredential.name, undefined, undefined));
}

function update$1(tenant, id, form) {
  const request = Curry._3(Buhta_keychainapis__Buhta_keychain_v1_credential_service.Buhta.Keychain.V1.UpdateCredentialRequest.make, id, form, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.credential);
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_keychainapis__Buhta_keychain_v1_credential_service.Buhta.Keychain.V1.CredentialService.updateCredential, undefined, undefined, tenant, Buhta_keychainapis__Buhta_keychain_v1_credential_service.Buhta.Keychain.V1.CredentialService.UpdateCredential.name, undefined, undefined));
}

const CredentialService = {
  view: view$1,
  grid: grid$1,
  create: create$1,
  update: update$1
};

export {
  Credential,
  Key,
  CredentialForm,
  KeyForm,
  KeyService,
  CredentialService,
}
/* Buhta_core__Grpc Not a pure module */
